import styled from 'styled-components';
import Slider from 'react-slick';

import { color } from 'theme/selectors';

export const StyledSlider = styled(Slider)<{ sliderWidth: number; paddingBtwSlides: number }>`
    width: ${({ sliderWidth }) => sliderWidth}px;
    margin-bottom: 56px;

    .slick-list {
        overflow: initial !important;
    }

    .slick-slide {
        padding-right: ${({ paddingBtwSlides }) => paddingBtwSlides}px;
        box-sizing: border-box;
        display: flex !important;
        justify-content: center;
    }

    .slick-dots {
        display: flex !important;
        justify-content: center;
        bottom: -22px;
    }

    @media (min-width: 400px) {
        .slick-dots {
            left: 32px;
        }
    }

    .slick-dots li {
        width: 6px;
        height: 6px;
    }

    .slick-dots li button {
        margin-right: 12px;
        width: inherit;
        height: inherit;
        background-color: ${color('border-default')};
        transition: 0.3s;
        padding: 0;
        border-radius: 6px !important;
    }

    .slick-dots li.slick-active {
        width: 24px;
    }

    .slick-dots li.slick-active button {
        width: inherit;
        background-color: ${color('text-secondary-subdued')};
        border-radius: 100%;
    }

    .slick-dots li button:before {
        content: none;
    }
`;
